
const $=window.jQuery;

class Utils {

    static async wait(sel) {
        return Utils._wait(sel, 0);
    }

    static async _wait(sel, retry)
    {
        const s = $(sel);
        if (s.length === 0) {
            if (retry > 4) {
                throw new Error(`Element ${sel} not found after 4 retries, giving up`);
            }
            await new Promise(resolve => setTimeout(resolve, 500));
            return await Utils._wait(sel, retry + 1);
        } else {
            // console.log(`Element ${sel} found at try ${retry}`);
            return s;
        }
    }
}

export default Utils;
